import { render, staticRenderFns } from "./ProfessorSchedule.vue?vue&type=template&id=7fccd068&scoped=true&"
import script from "./ProfessorSchedule.vue?vue&type=script&lang=js&"
export * from "./ProfessorSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fccd068",
  null
  
)

export default component.exports